import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_workers_informed_about_their_individual_wages_deductions'

export const dataPointDefinition = {
  retracedId: 'are_workers_informed_about_their_individual_wages_deductions',
  name: 'Are workers informed about their individual wages and deductions in line with legal requirements (e.g. through pay slips',
  description: 'Consult applicable legal requirements before answering this question.',
  meta: {
    slcpMeta: {
      key: 'wb-16',
      number: 'WB-WAGE-108',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-16', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35050,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
